/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams, Link } from "react-router-dom";
import { loginModal, businessLoginModal, brand } from "../../../config/appData";
import SuccessModal from "../../components/SuccessModal";
import "../../components/LoginModal/LoginModal.css";
import { useLoginForm } from "../../../utils/loginForm";
import loginUserImage from "../../../assets/login-user.png";
import loginBusinessImage from "../../../assets/login-business.png";
import "./LoginPage.css";
import { useAppDispatch } from "../../../Utility";
import { onLoginUserReset } from "../../../Store/Slices/loginSlice";
const TAB_USER = "user";
const TAB_BUSINESS = "business";

function LoginPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const typeFromUrl = searchParams.get("type");
  const [activeTab, setActiveTab] = useState(() =>
    typeFromUrl === "business" ? TAB_BUSINESS : TAB_USER,
  );
  const isBusiness = activeTab === TAB_BUSINESS;
  const modalConfig = isBusiness ? businessLoginModal : loginModal;
const dispatch = useAppDispatch();

  const userType = activeTab;

  useEffect(() => {
    setActiveTab(typeFromUrl === "business" ? TAB_BUSINESS : TAB_USER);
  }, [typeFromUrl]);

  const switchTab = (tab) => {
    setActiveTab(tab);
    if (tab === TAB_BUSINESS) {
      setSearchParams({ type: "business" }, { replace: true });
    } else {
      setSearchParams({}, { replace: true });
    }
  };

  const {
    formData,
    showPassword,
    setShowPassword,
    errors,
    handleChange,
    handleSubmit,
    handleSuccessComplete,
    isLoading,
    isSuccess,
    setIsSuccess,
  } = useLoginForm(userType);

  const navigate = useNavigate();
  const isDisabled = isLoading || isSuccess;
useEffect (()=>{
dispatch(onLoginUserReset());
},[])
  const formContent = (
    <>
      <div className="modal-divider"></div>
      <form onSubmit={handleSubmit}>
        <div className="input-group">
          <svg
            className="input-icon"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
            <polyline points="22,6 12,13 2,6"></polyline>
          </svg>
          <input
            type="email"
            name="email"
            className={`email-input ${errors.email ? "input-error" : ""}`}
            placeholder={modalConfig.emailPlaceholder}
            value={formData.email}
            onChange={handleChange}
            autoFocus
            disabled={isDisabled}
          />
        </div>
        {errors.email && <span className="error-message">{errors.email}</span>}
        <div
          className="input-group input-group-password"
          style={{ marginTop: "1rem" }}
        >
          <svg
            className="input-icon"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
          <input
            type={showPassword ? "text" : "password"}
            name="password"
            className={`email-input ${errors.password ? "input-error" : ""}`}
            placeholder="Enter your password"
            value={formData.password}
            onChange={handleChange}
            disabled={isDisabled}
          />
          <button
            type="button"
            className="password-toggle-btn"
            aria-label={showPassword ? "Hide password" : "Show password"}
            onClick={() => setShowPassword((p) => !p)}
            tabIndex={-1}
          >
            {showPassword ? (
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
                <line x1="1" y1="1" x2="23" y2="23"></line>
              </svg>
            ) : (
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                <circle cx="12" cy="12" r="3"></circle>
              </svg>
            )}
          </button>
        </div>
        {errors.password && (
          <span className="error-message">{errors.password}</span>
        )}
        <div className="login-forgot-wrap">
          <Link
            to="/forgot-password"
            className="login-forgot-link"
          >
            Forgot password?
          </Link>
        </div>
        <button
          type="submit"
          className={`modal-btn btn-login ${isLoading ? "btn-loading" : ""}`}
          style={{ marginTop: "1.5rem", width: "100%" }}
          disabled={isDisabled}
        >
          {isLoading ? (
            <>
              <svg
                className="spinner"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle
                  cx="12"
                  cy="12"
                  r="10"
                  strokeDasharray="60"
                  strokeDashoffset="30"
                >
                  <animate
                    attributeName="stroke-dasharray"
                    values="60;120;60"
                    dur="1.5s"
                    repeatCount="indefinite"
                  />
                  <animate
                    attributeName="stroke-dashoffset"
                    values="0;60;0"
                    dur="1.5s"
                    repeatCount="indefinite"
                  />
                </circle>
              </svg>
              Logging in...
            </>
          ) : (
            <>Login</>
          )}
        </button>
      </form>
      <p className="modal-no-account">
        {modalConfig.noAccountText}{" "}
        <button
          type="button"
          className="modal-link-create"
          onClick={() =>
            navigate(isBusiness ? "/register?type=business" : "/register")
          }
          disabled={isDisabled}
        >
          {modalConfig.createAccountText}
        </button>
      </p>
      <div className="modal-extra-links">
        {!isBusiness ? (
          <button
            type="button"
            className="modal-extra-link"
            onClick={() => switchTab(TAB_BUSINESS)}
            disabled={isDisabled}
          >
            {modalConfig.businessLoginText}
          </button>
        ) : (
          <button
            type="button"
            className="modal-extra-link login-page-user-link"
            onClick={() => switchTab(TAB_USER)}
            disabled={isDisabled}
          >
            Log in as user
          </button>
        )}
        <span className="modal-extra-sep">·</span>
        <button
          type="button"
          className="modal-extra-link"
          onClick={() => navigate("/admin/login")}
          disabled={isDisabled}
        >
          {modalConfig.adminLoginText}
        </button>
      </div>
    </>
  );

  return (
    <div className="login-page">
      <div
        className={`login-page-card modal-content-split ${isSuccess ? "modal-success" : ""}`}
      >
        <Link to="/" className="login-page-back" aria-label="Back to home">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          Back
        </Link>
        <div className="modal-left">
          <div className="login-page-brand-wrap" onClick={() => navigate("/")}>
            <div className="modal-header-inline">
              <span className="modal-logo">{brand.logoIcon}</span>
              <span className="modal-brand-name">{brand.name}</span>
            </div>
          </div>
          <div className="login-page-tabs">
            <button
              type="button"
              className={`login-page-tab ${activeTab === TAB_USER ? "active" : ""}`}
              onClick={() => switchTab(TAB_USER)}
              disabled={isDisabled}
            >
              User
            </button>
            <button
              type="button"
              className={`login-page-tab ${activeTab === TAB_BUSINESS ? "active" : ""}`}
              onClick={() => switchTab(TAB_BUSINESS)}
              disabled={isDisabled}
            >
              Business
            </button>
          </div>
          <h2 className="modal-title">{modalConfig.title}</h2>

          {formContent}
        </div>
        <div className="modal-right">
          <img
            key={activeTab}
            src={
              activeTab === TAB_BUSINESS ? loginBusinessImage : loginUserImage
            }
            alt=""
            className="modal-right-image login-page-right-image"
          />
          <div className="modal-right-overlay" />
          <div className="modal-right-content">
            <h3 className="modal-right-headline">
              {modalConfig.promoHeadline}
            </h3>
            <p className="modal-right-subtitle">{modalConfig.promoSubtitle}</p>
          </div>
        </div>
      </div>
      <SuccessModal
        isOpen={isSuccess}
        onClose={() => setIsSuccess(false)}
        title="Login Successful!"
        subtitle="Redirecting you..."
        onComplete={handleSuccessComplete}
        delay={800}
      />
    </div>
  );
}

export default LoginPage;
